// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2PqaY","header":"ReportDetails_header__28anl","title":"ReportDetails_title__YWUod","left":"ReportDetails_left__3MA0R"};